<template>
    <div class="long-page-sheet">
        <the-summary />
        <the-showroom />
        <!--<the-arguments />-->
        <the-features />
        <the-accessories />
        <the-equipments />
    </div>
</template>

<script>
import TheSummary from "./Summary";
import TheShowroom from "./Showroom";
import TheArguments from "./Arguments";
import TheFeatures from "./Features";
import TheAccessories from "./Accessories";
import TheEquipments from "./Equipments";

export default {
    name: 'MachineLongPageView',
    components: {
        TheSummary,
        TheShowroom,
        TheArguments,
        TheFeatures,
        TheAccessories,
        TheEquipments,
    },
}
</script>